import { render, staticRenderFns } from "./product-table-modal.vue?vue&type=template&id=8891d61e&"
import script from "./product-table-modal.vue?vue&type=script&lang=js&"
export * from "./product-table-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports